<template>
  <application-modal v-if="visible">
    <div class="amb-modal-header py-1 d-flex justify-content-between">
      <div class="d-flex px-3 align-items-center">
        <h2 class="modal-title mb-0 mr-3" id="exampleModalLabel">Send Bank Statement</h2>
      </div>
      <div class="p-3 amb-close-modal" @click="visible = false">
        <i class="fas fa-lg fa-times text-white"></i>
      </div>
    </div>

    <div class="container">
      <div class="row pt-0 amb-modal-body" style="-ms-overflow-y: auto; overflow-y: auto;">
        <div class="col-12 my-3">
          <!-- <p class="my-3">Send bank statement.</p> -->

          <div class="mb-3">
            <application-checkbox
              style="display: none;"
              type="hidden"
              class="mb-2"
              :checked.sync="sendEmail"
            >Send email to customer?</application-checkbox>
          </div>
          <div v-if="sendEmail">
            <p class="mb-1">
              <strong>To</strong>
            </p>
            <div v-for="(applicant) in applicants" :key="applicant.id">
              <div class="d-flex align-items-center amb-toggle-row-modal mb-1">
                <div class="amb-table-check-container mr-2">
                  <input
                    class="table-checkbox"
                    type="checkbox"
                    :value="applicant.email"
                    v-model="to"
                    :checked="to.includes(applicant.email)"
                    :disabled="!sendEmail"
                  />
                  <span class="amb-table-checkmark"></span>
                </div>
                <p>{{ applicant.first_name}} {{ applicant.last_name }} ({{ applicant.email }})</p>
              </div>
              <div
                class="d-flex align-items-center amb-toggle-row-modal mb-1"
                v-if="applicant.email2"
              >
                <div class="amb-table-check-container mr-2">
                  <input
                    class="table-checkbox"
                    type="checkbox"
                    :value="applicant.email2"
                    v-model="to"
                    :checked="to.includes(applicant.email2)"
                    :disabled="!sendEmail"
                  />
                  <span class="amb-table-checkmark"></span>
                </div>
                <p class="w-100">
                  {{ applicant.first_name}} {{ applicant.last_name }} ({{ applicant.email2 }})
                  <span
                    class="ml-2 badge badge-secondary btn-light-blue"
                  >Secondary</span>
                </p>
              </div>
            </div>

            <multi-input :model.sync="cc" :disabled="!sendEmail" label="Cc"></multi-input>

            <application-input
              class="input-belt mb-3"
              v-model="subject"
              :disabled="!sendEmail"
            >Subject</application-input>

            <div class="input-belt mb-3">
              <h3 for="email-comments">Email Comments</h3>

              <small>Enter any notes or comments to be included as 'broker notes' in email to the customer.</small>
              <summernote :model.sync="emailComments"></summernote>
              <a
                href="#0"
                class="text-btn-l-blue-bold mt-2 text-right"
                v-on:click.prevent="previewEmailBank"
              >
                Preview Email
                <i class="fas fa-eye ml-1"></i>
              </a>
            </div>
          </div>

          <add-attachments
            :selected-data.sync="selectedDocuments"
            :doc-documents.sync="docDocuments"
            :show-title="true"
            ></add-attachments>

          <button class="col-12 my-3 btn-green w-100" @click="sendEmailBank">Send Email</button>
        </div>
      </div>
    </div>
  </application-modal>
</template>
<script>
import DefaultTemplate from "./application-steps/scripts/DefaultTemplate";
import AddAttachments from "./documents/AddAttachments.vue";
export default {
  props: {
    open: {
      type: Boolean,
      required: true
    },
    applicants: {
      type: Array,
      required: true
    },
    docDocuments: {
      type: Array,
      required: true
    }
  },
  components: {
    "add-attachments": AddAttachments
  },
  data() {
    return {
      visible: false,
      sendEmail: false,
      cc: "",
      to: [],
      emailComments: "",
      selectedDocuments: [],
      emailTemplateBank: null,
      subject: null
    };
  },
  mounted() {
    this.defaultTemplate();
  },
  methods: {
    sendEmailBank() {
      if (this.sendEmail && this.to.length == 0) {
        this.visible = false;
        swal("Error", "Please select applicants", "error");
      } else {
        // send message here

        axios
          .post(
            `/api/v2/applications/${this.$store.getters.initAppData.id}/bank-statement`,
            {
              to: this.to,
              cc: this.cc,
              comment: this.emailComments,
              subject: this.subject,
              attachments: this.selectedDocuments,
              templateid: this.emailTemplateBank.id
            },
            {
              headers: { Authorization: "Bearer " + this.$store.getters.token }
            }
          )
          .then(res => {
            this.visible = false;
            this.$message({
              message: "Message sent",
              type: "success"
            });
          })
          .catch(err => {
            console.error("err====");
            console.error(err);
            this.$message({
              message: "Request Failed",
              type: "error"
            });
          });
      }
    },
    previewEmailBank() {
      axios
        .post("/admin/preview/templated/mail", {
          notes: this.emailComments
        })
        .then(res => {
          let previewUrl = "/admin/preview/templated/mail?preview=1";
          previewUrl += "&application_id=" + this.$store.getters.initAppData.id;

          if (this.emailTemplateBank) {
            previewUrl += "&template_id=" + this.emailTemplateBank.id;
          }
          window.open(previewUrl);
        })
        .catch(err => {
          console.error(err.response.data);
        });
    },
    async defaultTemplate() {
      try {
        let request = new DefaultTemplate(
          1,
          this.$store.getters.token,
          "send-bank-statement"
        );
        let res = await request.handle();
        this.emailTemplateBank = res;

        if (this.emailTemplateBank) {
          this.subject = this.emailTemplateBank.subject;
        }
      } catch (err) {
        console.error(err);
      }
    }
  },
  watch: {
    open(newVal, oldVal) {
      this.visible = newVal;
    },
    visible(newVal, oldVal) {
      this.$emit("update:open", newVal);
    }
  }
};
</script>
